import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProjectPhotoAnnotationModel, ProjectPhotoModel, ProjectPhotoUnifiedModel } from '../models/projectphoto.model';
import { ApiService } from '../core/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectphotoService {
  private baseUrl = 'ProjectPhoto';

  constructor(private apiService: ApiService) { }

  getProjectPhotos(projectId: number): Observable<ProjectPhotoModel[]> {
    return this.apiService.get(`${this.baseUrl}/GetProjectPhotos/${projectId}`);
  }

  // Get project photos without showing global loading spinner
  getProjectPhotosWithoutSpinner(projectId: number): Observable<ProjectPhotoModel[]> {
    return this.apiService.getWithoutSpinner(`${this.baseUrl}/GetProjectPhotos/${projectId}`);
  }

  // Get all project photos including skid checklist photos
  getAllProjectPhotos(projectId: number): Observable<ProjectPhotoUnifiedModel[]> {
    return this.apiService.get(`${this.baseUrl}/GetAllProjectPhotos/${projectId}`);
  }

  addProjectPhoto(formData: FormData): Observable<any> {
    return this.apiService.post(`${this.baseUrl}/AddProjectPhoto`, formData);
  }

  deleteProjectPhoto(photoId: number): Observable<any> {
    return this.apiService.delete(`${this.baseUrl}/DeleteProjectPhoto/${photoId}`);
  }

  deleteSkidPhoto(fileId: number): Observable<any> {
    return this.apiService.delete(`BlockScheduleFile/DeleteFile/${fileId}`);
  }

  bulkDeletePhotos(projectPhotoIds: number[], skidPhotoIds: number[]): Observable<any> {
    return this.apiService.post(`${this.baseUrl}/BulkDeletePhotos`, { projectPhotoIds, skidPhotoIds });
  }

  getProjectPhotoAnnotation(photoId: number): Observable<ProjectPhotoAnnotationModel> {
    return this.apiService.get(`${this.baseUrl}/GetProjectPhotoAnnotation/${photoId}`);
  }

  updateProjectPhotoAnnotation(photoId: number, annotationXfdf: string | null): Observable<any> {
    return this.apiService.put(`${this.baseUrl}/UpdateProjectPhotoAnnotation/${photoId}`, { annotationXfdf });
  }

  downloadProjectPhoto(photoId: number, optimized: boolean): Observable<Blob> {
    return this.apiService.getBlob(`${this.baseUrl}/DownloadProjectPhoto/${photoId}?optimized=${optimized}`);
  }
}
